import { Grid } from '@material-ui/core';
import styled from 'styled-components';

const StyledInputWrapper = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
});

export default StyledInputWrapper;